import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Services from './pages/Services';
import Products from './pages/Products';
import Contact from './pages/Contact';
import CategoryPage from './pages/CategoryPage';
import ProductPage from './pages/ProductPage';
import AllProducts from './pages/AllProducts';
import AllSolutions from './pages/AllSolutions';
import SolutionPage from './pages/SolutionPage';
import Blog from './pages/Blog';
import BlogDetail from './pages/BlogDetail';

function App() {
  return (
    <Router>
      <div className="flex flex-col min-h-screen">
        <Navbar />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/solutions-we-provide" element={<Services />} />
            <Route path="/solutions-we-provide/all" element={<AllSolutions />} />
            <Route path="/solution/:solutionSlug" element={<SolutionPage />} />
            <Route path="/products" element={<Products />} />
            <Route path="/products/all" element={<AllProducts />} />
            <Route path="/product/:productSlug" element={<ProductPage />} />
            <Route path="/products/:categorySlug" element={<CategoryPage />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:blogSlug" element={<BlogDetail />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
